import { CheckDL } from "../utils/CheckDL";
import {
  enumChartOpenModes,
  enumUIModes,
  enumUISubModes,
  featureConfig,
  gUIFont,
  kAccountActive,
  kAccountExpired,
  kAccountTrialExpired,
  kROUser,
  legacyToRouteParamMap
} from "../constants";
import { pgup } from "../utils/pgup";
import { uViewerButtonColor, enumButtonColors } from "../whitelabel/brand";
import { Globals } from "./Globals";
import { LocationSource } from "./LocationSource";
import { StringToBool } from "../utils/StringToBool";

export class QAccountInfo {
  constructor() {
    this.fEdition = null;
    this.fLaunchMode = null;
    this.fLaunchSubMode = null;
    this.fDecodedDLParams = null;
    this.fAccountStatus = null;
    this.fLaunchFile = null;
    this.fLaunchDirectory = null;
    this.fLaunchView = null;
    this.fURLUser = null;
    this.fURLLevels = null;
    this.fSParam = null;
    this.fURLAction = null;
    this.fDoNotPoll = false;
    this.fShowTabs = false;
    this.fTopTab = null;
    this.fUserType = null;

    this.fPSToken = null;
    this.fSaveAfterRefresh = false;

    this.fTopBoxID = null;

    this.fDiv = null;
    this.ssoFail = null;

    this.fTrialStart = null;
    this.fSupportSignIn = null;

    this.fADPLaunch = false;
    this.fReportToWebDriver = false;

    this.fToken = null;
    this.fAPIServer = null;

    this.fLaunchPlanID = null;

    this.fUIColors = [];
    this.fButtonColor = uViewerButtonColor;
    this.fUIProfile = null;
    this.fDynChartID = null;
    this.fForcePrompts = false;

    this.fMaxRecordLimit = { single: 350, multi: 20000 };

    this.fFeatures = {};
    this.fOnboardingNeeded = false;

    this.fLaunchHref = null;
  }

  CaptureLaunchURL() {
    this.fLaunchHref = window.location.href;
  }

  HandleReportIssueFunction(href, launchHref = href) {
    Globals._uiConfig.fHasReportIssue = false;
    var enabledReview = pgup("review", launchHref);
    if (enabledReview == null) enabledReview = pgup("review", href);
    if (enabledReview != null) Globals._uiConfig.fHasReportIssue = enabledReview;
  }

  BroadcastOIDC(code, state) {
    const channel = new BroadcastChannel("oidc");
    channel.postMessage({ code, state });
    window.close();
  }

  LoadURLParameters() {
    const decode = v => (v != null ? decodeURIComponent(v) : null);

    const launchHref = this.fLaunchHref ?? LocationSource.getHref();

    var turbosession = pgup("turbosession", launchHref);
    if (turbosession == "true") {
      Globals._timeoutLen = 10 * 1000;
      Globals._graceTime = 5;
    }

    var supportsignin = pgup("supportsignin", launchHref);
    this.fSupportSignIn = decode(supportsignin);

    var pstoken = pgup("pstoken", launchHref);
    this.SetPSToken(decode(pstoken));

    var deeplink = pgup("dl", launchHref);
    var href = launchHref;
    if (deeplink != null) {
      var dlinfo = CheckDL(deeplink);
      if (dlinfo != null) href = "http://localhost/?" + dlinfo;
    }

    var adplaunch = pgup("adp", href);
    if (adplaunch != null) this.fADPLaunch = true;

    var ssoFail = pgup("ssoFail", href);
    if (ssoFail != null) this.ssoFail = ssoFail;

    const code = pgup("code", launchHref);
    const state = pgup("state", launchHref);
    if (code && state) {
      this.BroadcastOIDC(code, state);
    }

    var launchToken = pgup("token", launchHref);
    if (launchToken == null) launchToken = pgup("token", href);
    if (launchToken) this.SetSSOToken(decode(launchToken));

    this.HandleReportIssueFunction(href, launchHref);

    var planID = pgup("launchPlanID", href);
    if (planID != null) {
      this.fLaunchPlanID = decode(planID);
      this.fLaunchSubMode = enumUIModes.planning;
    }

    var lMode = pgup("mode", href);
    if (lMode) lMode = lMode.toLowerCase();
    switch (lMode) {
      case "workbench":
      case "edit":
      case "standard":
        this.fLaunchMode = enumUIModes.edit;
        break;
      case "directory":
        this.fLaunchMode = enumUIModes.directory;
        break;
      case "planning":
        this.fLaunchMode = enumUIModes.planning;
        break;
      case "viewmanager":
        this.fLaunchMode = enumUIModes.viewmanager;
        break;
      case "portal":
      case "iframe":
      case "viewer":
      case "chart":
        this.fLaunchMode = enumUIModes.chart;
        break;
      //default:
      //   this.fLaunchMode = enumUIModes.edit;
    }
    var submode = pgup("submode", href);
    if (submode) submode = submode.toLowerCase();
    switch (submode) {
      case "directory":
        this.fLaunchMode = enumUIModes.directory;
        break;
      case "planning":
        this.fLaunchMode = enumUIModes.planning;
        break;
    }

    var hideTabs = pgup("hidetabs", href);
    if (hideTabs) {
      Globals._uiConfig.fHasProfile = hideTabs.indexOf("Profile") === -1;
      Globals._uiConfig.fHasSubcharts = hideTabs.indexOf("Subcharts") === -1;
      Globals._uiConfig.fHasSearch = hideTabs.indexOf("Search") === -1;
    }

    var urlUser = pgup("user", launchHref);
    if (urlUser == null) urlUser = pgup("user", href);
    this.fURLUser = decode(urlUser);

    var sp = pgup("s", launchHref);
    if (sp == null) sp = pgup("s", href);
    this.fSParam = sp;

    var filemgr = pgup("filemgr", launchHref);
    if (filemgr == null) filemgr = pgup("filemgr", href);
    if (filemgr != null && StringToBool(filemgr) != Globals._uiConfig.fCanFilemgr) {
      Globals._uiConfig.fCanFilemgr = StringToBool(filemgr);
      Globals._uiConfig.fHadURLParams = true;
    }
    var excel = pgup("excel", launchHref);
    if (excel == null) excel = pgup("excel", href);
    if (excel != null && StringToBool(excel) != Globals._uiConfig.fCanExportExcel) {
      Globals._uiConfig.fCanExportExcel = StringToBool(excel);
      Globals._uiConfig.fHadURLParams = true;
    }

    var publish = pgup("publish", launchHref);
    if (publish == null) publish = pgup("publish", href);
    if (publish != null && StringToBool(publish) != Globals._uiConfig.fCanPublish) {
      Globals._uiConfig.fCanPublish = StringToBool(publish);
      Globals._uiConfig.fHadURLParams = true;
    }

    var portalSubMode = pgup("pmode", href);

    this.fURLAction = pgup("action", launchHref) ?? pgup("action", href);
    //TODO: this could be used for publishing but also anything automated.
    if (this.fURLAction) {
      this.fURLAction = decode(this.fURLAction);
      this.fURLAction = this.fURLAction.split(",");
      // Do not poll for new notifications
      this.fDoNotPoll = true;
      this.fReportToWebDriver = true;
    }

    const enumPortalMode = {
      std: 0,
      nofilemgr: 1,
      nofilemgrnoexcel: 2,
      nofilemgrnopub: 3,
      nopub: 4,
      notools: 5,
      noexcel: 6
    };
    var portalSubMode = parseInt(portalSubMode);
    switch (portalSubMode) {
      case enumPortalMode.nofilemgr:
        Globals._uiConfig.fCanFilemgr = false;
        Globals._uiConfig.fHadURLParams = true;
        break;
      case enumPortalMode.nofilemgrnoexcel:
        Globals._uiConfig.fCanFilemgr = false;
        Globals._uiConfig.fCanExportExcel = false;
        Globals._uiConfig.fHadURLParams = true;
        break;
      case enumPortalMode.nofilemgrnopub:
        Globals._uiConfig.fCanFilemgr = false;
        Globals._uiConfig.fCanPublish = false;
        Globals._uiConfig.fHadURLParams = true;
        break;
      case enumPortalMode.nopub:
        Globals._uiConfig.fCanPublish = false;
        Globals._uiConfig.fHadURLParams = true;
        break;
      case enumPortalMode.notools:
        Globals._uiConfig.fCanFilemgr = false;
        Globals._uiConfig.fCanPublish = false;
        Globals._uiConfig.fCanExportExcel = false;
        Globals._uiConfig.fHadURLParams = true;
        break;
      case enumPortalMode.noexcel:
        Globals._uiConfig.fCanExportExcel = false;
        Globals._uiConfig.fHadURLParams = true;
        break;
    }
    var dynid = pgup("dynid", launchHref);
    if (dynid == null) dynid = pgup("dynid", href);
    if (dynid != null) this.fDynChartID = dynid;

    var usergroup = pgup("testgroup", launchHref);
    if (usergroup != null) {
      Globals._accountInfo.fUserTestGroup = usergroup;
    }

    var forcePrompts = pgup("seePrompts", launchHref);
    if (forcePrompts == "true") {
      Globals._accountInfo.fForcePrompts = true;
    }

    var mfaSetup = pgup("mfaSetup", launchHref);
    if (mfaSetup == null) mfaSetup = pgup("mfaSetup", href);
    this.fMFASetup = mfaSetup;

    this.ApplyLaunchParams({
      language: pgup("language", launchHref),
      file: decode(pgup("file", href)),
      directory: decode(pgup("directory", href)),
      chartID: pgup("chartID", launchHref) ?? pgup("chartID", href),
      mwoff: pgup("mwoff", launchHref) ?? pgup("mwoff", href),
      division: decode(pgup("division", launchHref) ?? pgup("division", href)),
      topboxid: decode(pgup("topboxid", launchHref) ?? pgup("topboxid", href)),
      zoom: pgup("zoom", href),
      bleHoverBar: pgup("bleHoverBar", launchHref),
      bkgrnd: pgup("bkgrnd", href),
      selflaunch: pgup("selflaunch", launchHref) ?? pgup("selflaunch", href),
      launchprofile: pgup("launchprofile", launchHref) ?? pgup("launchprofile", href),
      levels: pgup("levels", launchHref) ?? pgup("levels", href),
      view: pgup("view", launchHref) ?? pgup("view", href)
    });

    // Snapshot decoded dl params for the React redirect hook.
    // Uses the raw decoded query string and the legacy→route param map so
    // adding a new param is one line in legacyToRouteParamMap — no manual
    // global-to-param reconstruction needed.
    if (deeplink != null && dlinfo != null) {
      const dlSearch = new URLSearchParams(dlinfo);
      this.fDecodedDLParams = {};
      for (const [legacyKey, newKey] of Object.entries(legacyToRouteParamMap)) {
        const val = dlSearch.get(legacyKey);
        if (val != null) this.fDecodedDLParams[newKey] = val;
      }
    }

    this.fLaunchHref = null;
  }

  LoadInitParameters(metadata) {
    if (metadata["user"]) {
      Globals._uiConfig.SetLaunchMode(enumUIModes.chart);
      Globals._uiConfig.SetChartOpenMode(enumChartOpenModes.masterchart);
      this.fAutoUser = metadata["user"];
    }

    if (metadata["APIserver"]) this.fAPIServer = metadata["APIserver"];

    if (metadata["hasUpgradeButton"] === true) this.fHasPaywallButton = true;

    if (metadata["imageBaseUrl"]) this.fImageBaseUrl = metadata["imageBaseUrl"];

    this.ApplyLaunchParams(metadata);
  }

  ApplyLaunchParams(params) {
    if (params.language) localStorage.language = params.language;
    if (params.file != null) this.fLaunchFile = params.file;
    if (params.directory != null) this.fLaunchDirectory = params.directory;
    if (params.chartID != null) this.fLaunchChartID = params.chartID;
    if (params.division != null) this.fDiv = params.division;
    if (params.topboxid != null) this.SetTopBoxID(params.topboxid);
    if (params.zoom != null) this.SetStartZoom(params.zoom);
    if (params.mwoff === "true") Globals._uiConfig.fEnableMouseWheel = false;
    if (params.bleHoverBar === "true") Globals._uiConfig.fBLEHoverBarEnabled = true;
    if (params.bkgrnd != null) Globals._uiConfig.fBackgroundColor = "#" + params.bkgrnd;
    if (params.selflaunch != null) {
      Globals._uiConfig.SetIsSelfLaunch(
        params.selflaunch == "true" || params.selflaunch === "True"
      );
      Globals._uiConfig.fHadURLParams = true;
    }
    if (params.launchprofile != null) this.fUIProfile = params.launchprofile;
    if (params.levels) this.SetLaunchLevels(parseInt(params.levels, 10));
    if (params.view != null) this.fLaunchView = params.view;
    if (params.onboardingNeeded != null) {
      this.SetOnboardingNeeded(params.onboardingNeeded);
    }
  }

  ReportToWebDriver() {
    return this.fReportToWebDriver;
  }

  SetStartZoom(startZoom) {
    switch (startZoom) {
      case "150":
        Globals._startZoom = 1.5;
        break;
      case "125":
        Globals._startZoom = 1.25;
        break;
      case "75":
        Globals._startZoom = 0.75;
        break;
      case "50":
        Globals._startZoom = 0.5;
        break;
      case "25":
        Globals._startZoom = 0.25;
        break;
      default:
        Globals._startZoom = 1;
        break;
    }
  }

  SetPSToken(psToken) {
    this.fPSToken = psToken;
  }

  //=============================================================
  GetPSToken() {
    return this.fPSToken;
  }

  SetSSOToken(token) {
    this.fToken = token;
  }

  GetSSOToken() {
    return this.fToken;
  }

  SetAPIServer(server) {
    this.fAPIServer = server;
  }

  GetAPIServer() {
    return this.fAPIServer;
  }

  GetImageBaseUrl() {
    return this.fImageBaseUrl;
  }

  SetOC5Edition(edition) {
    this.fEdition = edition;
  }

  GetOC5Edition() {
    return this.fEdition;
  }

  SetUserType(userType) {
    this.fUserType = userType;
  }

  GetUserRole() {
    return this.fUserType;
  }

  GetMaxRecords(singlePage = false) {
    if (singlePage) {
      return this.fMaxRecordLimit["single"];
    }

    return this.fMaxRecordLimit["multi"];
  }

  SetMaxRecords([single, multi]) {
    this.fMaxRecordLimit = { single, multi };
  }

  GetPaywallMode() {
    return this.fTrialStart;
  }

  SetPaywallMode(trialStart) {
    this.fTrialStart = trialStart;
  }

  GetAccountStatus() {
    return this.fAccountStatus;
  }

  SetAccountStatus(accountStatus) {
    this.fAccountStatus = accountStatus;
  }

  SetSandboxStatus(sandboxStatus) {
    this.fSandboxStatus = sandboxStatus;
  }

  GetSandboxStatus() {
    return this.fSandboxStatus;
  }

  SetLaunchMode(launchMode) {
    this.fLaunchMode = launchMode;
  }

  SetFeatures(features) {
    this.fFeatures = features;
  }

  SetOnboardingNeeded(onboardingNeeded) {
    this.fOnboardingNeeded = onboardingNeeded;
  }

  GetOnboardingNeeded() {
    return this.fOnboardingNeeded;
  }

  GetFeatures() {
    return this.fFeatures;
  }

  GetAccessibleFeature(feature) {
    //if feature is not in the list, return false
    if (!this.fFeatures[feature] || !(feature in this.fFeatures)) {
      return false;
    } else {
      return this.fFeatures[feature];
    }
  }

  //=============================================================
  OpenFileAtLaunch() {
    return this.fLaunchFile != null && this.fLaunchDirectory != null;
  }

  GetLaunchDirectory() {
    return this.fLaunchDirectory;
  }

  GetLaunchFile() {
    return this.fLaunchFile;
  }

  SetTopBoxID(topBoxID) {
    //This should only be for URL generator case.
    console.log("bad");
    this.fTopBoxID = topBoxID;
  }

  GetTopBoxID() {
    return this.fTopBoxID;
  }

  SetTopBoxIsAux(isAux) {
    this.fTopBoxIsAux = isAux;
  }

  GetTopBoxIsAux() {
    return this.fTopBoxIsAux;
  }

  GetDiv() {
    return this.fDiv;
  }

  SetLaunchUser(launchUser) {
    this.fURLUser = launchUser;
  }

  GetLaunchUser() {
    return this.fURLUser;
  }

  SetLaunchLevels(levels) {
    this.fURLLevels = levels;
  }

  GetLaunchLevels() {
    return this.fURLLevels;
  }

  GetLaunchSettings() {
    return {
      launchView: this.fLaunchView,
      launchLevels: this.GetLaunchLevels()
    };
  }

  ClearLaunchSettings() {
    this.fLaunchView = null;
    this.SetLaunchLevels(null);
  }

  GetSParam() {
    return this.fSParam;
  }

  GetURLAction() {
    if (this.fURLAction == null) return null;
    var action = this.fURLAction.shift();

    return action;
  }

  PublicURLLaunch() {
    // Public Launch requires
    // 1. In Portal Mode
    // 2. User is supplied
    // 3. Launch dir is "Public"

    var launchDir = this.GetLaunchDirectory();
    var inPortalMode = Globals._uiConfig.GetLaunchMode() == enumUIModes.chart;

    return this.GetLaunchUser() != null && launchDir == "Public" && inPortalMode;
  }

  PrivateURLLaunch() {
    var privateLaunch = this.GetPSToken() != null;
    return privateLaunch;
  }

  ClearLaunchURL() {
    this.fURLUser = null;
    this.fPSToken = null;
  }

  ClearURLAction() {
    this.fURLAction = null;
    this.fSaveAfterRefresh = false;
  }

  GetTopTab() {
    var topTab;
    if (this.fTopTab != null) topTab = this.fTopTab;
    else topTab = localStorage.toptab;

    return topTab;
  }

  GetAccountFontName() {
    return gUIFont;
  }

  //=============================================================
  ReadOnlyMode() {
    //This is a combo/catch all function designed to skip any scenario where the document can't be dirtied
    //Either the user doesn't have permissions or you're in an environment where that is not possible

    //THIS FUNCTION IS REFERRING TO READ ONLY IN A QXDOC PERSPECTIVE
    if (
      Globals._uiConfig.GetUIMode() != enumUIModes.edit &&
      !Globals._uiConfig.InBackgroundEditorMode() &&
      Globals._uiConfig.GetUIMode() != enumUIModes.boxlayouteditor
    )
      return true;

    var readonly = this.GetUserRole() == kROUser || this.GetAccountStatus() == kAccountTrialExpired;
    return readonly;
  }

  DoInitialMessage() {
    var accountStatus = this.GetAccountStatus();
    // Disabled or expired - always gets a message or Free Trial - always message
    if (accountStatus !== kAccountActive && accountStatus != null) {
      if (accountStatus === kAccountExpired && !Globals._wsMgr.GetOrgInfo().TestExpired()) {
        //factor in grace period
        return false;
      }
      return true;
    }

    // Account is a reader - no message
    if (this.GetUserRole() === kROUser) return false;

    var gotLaunchFile = this.GetLaunchFile() != null;
    if (gotLaunchFile) return false;

    // Coming up in a portal - no message
    //var portalMode = Globals._uiConfig.GetSubMode() == enumWorkbenchUIModes.portal;
    //if (portalMode)
    //	return false;

    return false;
  }

  TrialExpired() {
    var status = this.GetAccountStatus();
    return status === kAccountTrialExpired;
  }

  GetButtonColor() {
    var buttonColor = Globals._accountInfo.fButtonColor;
    if (Object.keys(enumButtonColors).indexOf(buttonColor) > -1)
      buttonColor = enumButtonColors[Globals._accountInfo.fButtonColor];
    return buttonColor;
  }

  GetDynChartID() {
    //This is specific to EY and not yet deprecated.
    return this.fDynChartID;
  }
}
